export const dateTimeCultures: Record<string, string> = {
  'dd/MM/yyyy HH:mm:ss.SSS': 'en-GB',
  'MM/dd/yyyy HH:mm:ss.SSS': 'en-US',
  'yyyy/MM/dd HH:mm:ss.SSS': 'zh-CN',
  'dd.MM.yyyy HH:mm:ss.SSS': 'de-DE',
  'yyyy.MM.dd HH:mm:ss.SSS': 'ja-JP'
};